import React, { useEffect, useState } from "react";

function UserDashboard() {
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    // Daten von der API abrufen
    fetch("https://www.denisbitter.de/stage01/api/get_user_dashboard.php", {
      method: "GET",
      credentials: "include", // Session-Cookies senden
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setCourses(data.data);
        } else {
          setError(data.message || "Fehler beim Laden der Daten.");
        }
      })
      .catch((err) => {
        console.error("Fehler:", err);
        setError("Server nicht erreichbar. Bitte später erneut versuchen.");
      });
  }, []);

  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold mb-6">Dein Dashboard</h1>
      {error && (
        <div className="bg-red-100 text-red-600 p-4 mb-4 rounded text-sm">
          {error}
        </div>
      )}
      {courses.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {courses.map((course) => (
            <div key={course.id} className="bg-gradient-to-br from-gray-100 via-white to-gray-100/50 p-6 rounded-lg shadow">
              <h2 className="text-lg font-semibold text-gray-800">
                {course.course}
              </h2>
              <p className="text-gray-600">Registriert am: {course.registration_date}</p>
              <p className="text-gray-600">Startdatum: {course.custom_date || "Kein Datum angegeben"}</p>
              <a
                href={`https://www.denisbitter.de/stage01/uploads/${course.pdf_path}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline mt-4 inline-block"
              >
                PDF herunterladen
              </a>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-600">Keine Kurse gefunden.</p>
      )}
    </div>
  );
}

export default UserDashboard;